import i18n from "@/_lang/lang"
import vuetify from '@/plugins/vuetify'

export const DEFAULT_LANGUAGE = "tr_TR"
export const DEFAULT_DARK = "false"

const app = {
    namespaced: true,
    state: {
        dark: DEFAULT_DARK,
        language: DEFAULT_LANGUAGE
    },

    getters: {
        language: state => state.language,
        dark: state => state.dark,
    },
    mutations: {
        SET_DARK: (state, dark) => {
            console.log("SET_DARK", dark);
            state.dark = dark
            vuetify.framework.theme.dark = dark;
            localStorage.setItem(DEFAULT_DARK, dark)
        },
        SET_LANGUAGE: (state, language) => {
            console.log("SET_LANGUAGE", language);
            state.language = language
            i18n.locale = language;
            localStorage.setItem(DEFAULT_LANGUAGE, language)
        }
    },

    actions: {
        init({ commit }) {
            commit("SET_DARK", JSON.parse(localStorage.getItem(DEFAULT_DARK) || DEFAULT_DARK))
            commit("SET_LANGUAGE", localStorage.getItem(DEFAULT_LANGUAGE) || DEFAULT_LANGUAGE)
        },
        setLanguage({ commit }, language) {
            commit("SET_LANGUAGE", language)
        },
        setDark({ commit }, dark) {
            commit("SET_DARK", dark)
        }
    }
}
export default app;